import { getTheme } from 'mol-ui';
import styled from 'styled-components';

export const Container = styled.a`
    align-items: center;
    background-color: #FFFFFF;
    border-radius: 0px 0px 4px 4px;
    display: flex;
    height: 30px;
    justify-content: center;
    left: calc(50% - 85px);
    outline: 1px solid ${ getTheme('primaryColor') };
    outline-offset: -2px;    
    position: fixed;
    top: -30px;
    transition: all 300ms ease;
    width: 170px;
    z-index: 99999;
    
    :focus,
    :focus-within {
        transform: translateY(30px);
    }
`;
